/**
 * Проверка, похоже ли значение на дату (Date или ISO-строка)
 * @param {*} value
 * @returns {boolean}
 */
function isDateLike(value) {
  return (
    value instanceof Date ||
    (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})?$/.test(value))
  );
}

/**
 * Преобразует значение в ISO-строку (нормализует дату)
 * @param {string | Date} value
 * @returns {string | null}
 */
function normalizeToISOString(value) {
  try {
    const date = value instanceof Date ? value : new Date(value);
    if (!isNaN(date)) return date.toISOString();
  } catch (e) {
    return null;
  }
  return null;
}

/**
 * Универсальный хелпер сравнения двух объектов: возвращает только изменённые поля.
 * Поддерживает сравнение дат в любых форматах (строка, Date), учитывает часовой пояс.
 * Преобразует пустые строки в null, если поле в original было заполнено.
 *
 * @param {Object} original - Оригинальный объект (например, из БД).
 * @param {Object} updated - Обновлённые данные (например, из формы).
 * @returns {Object} Объект с полями, которые были изменены.
 */
export function extractChangedFields(original, updated) {
  const result = {};

  for (const key in updated) {
    if (!Object.prototype.hasOwnProperty.call(updated, key)) continue;

    let originalVal = original[key];
    let updatedVal = updated[key];

    // Приводим '' к null для сравнения "пустого" значения
    const originalEmpty = originalVal === null || originalVal === '';
    const updatedEmpty = updatedVal === null || updatedVal === '';

    if (originalEmpty && updatedEmpty) continue;

    // Если updated стал пустым, но original был заполнен — кладём null
    if (!updatedEmpty && originalEmpty) {
      result[key] = updatedVal;
      continue;
    }

    if (updatedEmpty && !originalEmpty) {
      result[key] = null;
      continue;
    }

    // Нормализуем даты, если хотя бы одно значение — дата или ISO-строка
    const isDate = isDateLike(originalVal) || isDateLike(updatedVal);
    if (isDate) {
      const origISO = normalizeToISOString(originalVal);
      const updatedISO = normalizeToISOString(updatedVal);
      if (origISO !== updatedISO) {
        result[key] = updatedVal;
      }
    } else if (originalVal !== updatedVal) {
      result[key] = updatedVal;
    }
  }

  return result;
}
